var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "productsList", staticClass: "products-list" },
    [
      _vm._l(_vm.PRODUCTS, function(product) {
        return _c("product-list-item", {
          key: product.id,
          attrs: { product: product }
        })
      }),
      !_vm.END
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "reached",
                  rawName: "v-reached",
                  value: _vm.load,
                  expression: "load"
                }
              ],
              staticClass: "products-list-loader"
            },
            [
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _vm.PROGRESS
                    ? _c("ui-loader", { attrs: { size: "60" } })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }